<template>
  <div>
    <a href="tel:+33158012980">Phone : +33 (0) 1.58.01.29.80</a>
    <Loader v-if="isDataLoading"/>
    <div v-else>
        <Table
          :title="$t('views.invoices.title')"
          :headers="invoicesHeaders"
          :rows="invoicesRows"
          :values="invoices"
          @export="exportInvoices"/>
    </div>
  </div>

</template>

<script>
import INVOICES from '@/api/invoices';
import Table from '@/components/Table.vue';
import Loader from '@/components/Loader.vue';

export default {
  name: 'invoices',
  components: {
    Table,
    Loader,
  },
  data() {
    return {
      invoices: [],
      isDataLoading: true,
      invoicesHeaders: [
        {
          label: this.$t('views.invoices.config.invoicesHeaders.number'),
          field: 'number',
        },
        {
          label: this.$t('views.invoices.config.invoicesHeaders.amount'),
          field: 'amount',
        },
        {
          label: this.$t('views.invoices.config.invoicesHeaders.date'),
          field: 'date',
        },
        {
          label: '',
        },
      ],
      invoicesRows: [
        {
          value: row => row.number,
        },
        {
          value: row => `${row.amount / 100 }€`,
        },
        {
          value: row => row.date,
        },
        {
          value: row => this.$t('views.invoices.download'),
          classList: 'button is-gamma is-outline is-xsmall',
          link: row => ({
            href: INVOICES.download(row.id),
            alt: this.$t('views.invoices.download'),
            target: '_blank',
            download: true,
          }),
          icon: row => 'download-inverse',
        },
      ],
    }
  },
  computed: {
  },
  created() {
    this.init();
  },
  mounted() {

  },
  methods: {

    init() {
      this.listInvoices();
    },

    listInvoices() {
      INVOICES.list().then(
        (res) => {
          this.isDataLoading = false;
          if (res.data && res.data.count > 0) {
            this.invoices = res.data.results;
          }
        }, (err) => {
          this.isDataLoading = false;
        },
      );
    },

    exportInvoices() {
      INVOICES.export();
    },
  },
};
</script>
